'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSenderType = undefined;

var _reselect = require('reselect');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _getIsAdmin = require('../clientSelectors/getIsAdmin');

var getSenderType = exports.getSenderType = (0, _reselect.createSelector)(_getIsAdmin.getIsAdmin, function (isAdmin) {
  return isAdmin ? _senderTypes.AGENT : _senderTypes.VISITOR;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/pubNubMessageSelectors/getSenderType.js
// module id = 340
// module chunks = 2 3